<section class="carousel swiper" #swiperPromoContainer>
    <div class="swiper-wrapper carousel__wrapper">
        @for (slide of slides(); track slide.id; let idx = $index) {
            <section
                class="carousel__navigation swiper-slide"
                [ariaLabel]="'slide ' + (idx + 1) + ' of ' + slides()?.length"
            >
                <h2 class="carousel__navigation-title h2" [attr.aria-label]="slide.title">{{ slide.title }}</h2>
                <p class="carousel__navigation-descr body-1" [attr.aria-label]="slide.subTitle">
                    {{ slide.subTitle }}
                    @if (slide.linkLabel) {
                        <a
                            class="carousel__navigation-descr-link"
                            [attr.aria-label]="slide.linkLabel"
                            [routerLink]="slide.link ? [slide.link] : null"
                            [tabIndex]="activeIndex() === idx ? 0 : -1"
                        >
                            {{ slide.linkLabel }}
                            <mat-icon svgIcon="ico_arrow_right"></mat-icon>
                        </a>
                    }
                </p>
            </section>
        }
    </div>

    @if (isTwoOrMoreSlides()) {
        <div class="carousel__navigation-actions">
            @if (!isMobile()) {
                <mat-icon
                    class="carousel__navigation-action"
                    aria-label="Previous"
                    svgIcon="ico_caret_left"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="prevSlide()"
                ></mat-icon>
            }

            @if (isAutoplayEnabled()) {
                <mat-icon
                    class="carousel__navigation-action"
                    aria-label="Pause"
                    svgIcon="ico_pause"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="toggleAutoPlay()"
                ></mat-icon>
            } @else {
                <mat-icon
                    class="carousel__navigation-action"
                    aria-label="Play"
                    svgIcon="ico_play"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="toggleAutoPlay()"
                ></mat-icon>
            }

            @if (!isMobile()) {
                <mat-icon
                    class="carousel__navigation-action"
                    aria-label="Next"
                    svgIcon="ico_caret_right"
                    [attr.aria-hidden]="false"
                    (libAccessibleClick)="nextSlide()"
                ></mat-icon>
            }

            @if (isMobile()) {
                <div class="swiper-pagination carousel__pagination">
                    @for (slide of slides(); track slide.id; let idx = $index) {
                        <div
                            class="swiper-pagination-bullet carousel__pagination-bullet"
                            [class.swiper-pagination-bullet-active]="idx === activeIndex()"
                        ></div>
                    }
                </div>
            }
        </div>
    }
</section>
